import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'sera-old-footer-bar',
    templateUrl: './sera-old-footer-bar.component.html',
    styleUrls: ['./sera-old-footer-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SeraOldFooterBarComponent {}
